import React from "react";
import {
    Main,
    Timeline,
    Expertise,
    Contact,
} from "../components";
import FadeIn from '../components/FadeIn';
import '../index.scss';

function Home() {
    return (
        <FadeIn transitionDuration={700}>
            <Main/>
            <Expertise/>
            <Timeline/>
            <Contact/>
        </FadeIn>
    );
}

export default Home;